import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  SimpleChanges,
  ElementRef,
  ComponentRef,
  ViewContainerRef,
} from '@angular/core';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0300Model } from './kymw0300.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { PlessAlert } from './../../../shared/pless-alert/pless-alert.component';

import { CodeComboBoxComponent } from '../../kymw02/combo-box/code-combo-box/code-combo-box.component';
import { KYMW0400OutputModel } from '../../kymw04/kymw0400/vo/kymw0400-output.model';
import { KYMW0400Component } from '../../kymw04/kymw0400/kymw0400.component';
import { KYMW0300OutputModel } from './vo/kymw0300-output.model';
import { KYMW0300InputModel } from './vo/kymw0300-input.model';
import { CodeCheckBoxListComponent } from '../../kymw02/list/code-check-box-list/code-check-box-list.component';
import { KYMW0400InputModel } from '../../kymw04/kymw0400/vo/kymw0400-input.model';
import { ClassCodeComboBoxComponent } from '../../kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from '../../kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { SmallClassCodeComboBoxComponent } from '../../kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { WjAccordion } from '@grapecity/wijmo.angular2.nav';
import { KYMW0002Component } from '../../kymw00/kymw0002/kymw0002.component';
import { KYMW0001Component } from '../../kymw00/kymw0001/kymw0001.component';
import { GetFeatureCodeListService } from './api-services/get-feature-code-list.service';
import { KYMW0001InputModel } from '../../kymw00/kymw0001/vo/kymw0001-input.model';
import { FeatureCodeListModel } from './vo/feature-code-list.model';

namespace STYLE_VISIBILITY {
  export const HIDDEN = 'hidden';
  export const SHOW = '';
}
namespace DELIMITER_CHAR {
  export const GUIDE = ' ';
  export const PCODE = '\n';
  export const ITEM_CODE = '\n';
}

namespace PANEL_TAB_INDEX {
  export const NOMAL = 0;
  export const P_CODE_LIST = 1;
  export const ITEM_CODE_LIST = 2;
}

/**
 * 商品検索画面を管理するクラス
 *
 * @export KYMW0300Component
 * @class KYMW0300Component
 */
@Component({
  selector: 'app-kymw0300',
  templateUrl: 'kymw0300.component.html',
  styleUrls: ['kymw0300.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW0300Component extends PlessViewHelperSub implements OnInit {
  /** PCodeリストの最大表示件数 */
  private readonly PCODE_LIST_MAX_COUNT: number = 1000;

  public model: KYMW0300Model;
  private readonly MAX_LENGTH_FOR_TAGS = 30;
  private readonly MAX_LENGTH_FOR_GOODS_MARK = 30;
  private readonly MAX_LENGTH_FOR_CATALOG_MARK = 30;

  /** 全生協のチェック可否 */
  public allCoop: boolean = <boolean>false;

  @ViewChild('tbx_PCode', { static: true }) tbx_PCode: ElementRef;
  @ViewChild('lst_DutiesFormDaily', { static: true })
  lst_DutiesFormDaily: CodeCheckBoxListComponent;
  @ViewChild('cmb_ClassCode', { static: true })
  cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassification', { static: true })
  cmb_MiddleClassification: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassification', { static: true })
  cmb_SmallClassification: SmallClassCodeComboBoxComponent;
  @ViewChild('cmb_BuyerCode', { static: true })
  cmb_BuyerCode: CodeComboBoxComponent;
  @ViewChild('chk_AllCoop', { static: true }) chk_AllCoop: ElementRef;
  @ViewChild('chb_Seikyou1', { static: true }) chb_Seikyou1: ElementRef;
  @ViewChild('chb_Seikyou2', { static: true }) chb_Seikyou2: ElementRef;
  @ViewChild('chb_Seikyou3', { static: true }) chb_Seikyou3: ElementRef;
  @ViewChild('chb_Seikyou4', { static: true }) chb_Seikyou4: ElementRef;
  @ViewChild('chb_Seikyou5', { static: true }) chb_Seikyou5: ElementRef;
  @ViewChild('chb_Seikyou6', { static: true }) chb_Seikyou6: ElementRef;
  @ViewChild('chb_Seikyou7', { static: true }) chb_Seikyou7: ElementRef;
  @ViewChild('chb_Seikyou8', { static: true }) chb_Seikyou8: ElementRef;
  @ViewChild('cmb_admitStatus', { static: true })
  cmb_admitStatus: CodeComboBoxComponent;

  kymw0300Model: KYMW0300Model = new KYMW0300Model();

  // 親画面からの連携値
  inputVo: KYMW0300InputModel;

  // 親画面への連携用
  setKYMW0300Parameter: Function;

  // タグ選択
  public setId: string[] = [];
  public tagLength: number = 0;
  // マーク選択
  // 商品マーク
  public setGoodsMarkCode: string[] = [];
  public goodsMarkLength: number = 0;
  // 企画マーク
  public setCatalogMarkCode: string[] = [];
  public catalogMarkLength: number = 0;

  public isSupplier: boolean = false;

  // Pコードリスト件数
  public pcodeCount: number = 0;
  // アイテムコードリスト件数
  public itemcodeCount: number = 0;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;

  /**
   *Creates an instance of KYMW0300Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0300Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    private getFeatureCodeListService: GetFeatureCodeListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡されるデータ
   * @memberof KYMW0300Component
   */
  public setInterfaceParam(param: KYMW0300InputModel): void {
    // 親画面のinputVOをそのまま受け取る
    this.inputVo = param;
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0300Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0300';

    // CheckBox 初期化
    this.kymw0300Model.registDateCheck = false;
    this.kymw0300Model.updateDateCheck = false;
    this.kymw0300Model.seikyou1Selected = false;
    this.kymw0300Model.seikyou2Selected = false;
    this.kymw0300Model.seikyou3Selected = false;
    this.kymw0300Model.seikyou4Selected = false;
    this.kymw0300Model.seikyou5Selected = false;
    this.kymw0300Model.seikyou6Selected = false;
    this.kymw0300Model.seikyou7Selected = false;
    this.kymw0300Model.seikyou8Selected = false;
    this.kymw0300Model.dummyGoodsSelected = false;
    this.kymw0300Model.dutiesFormWeeklyDivSelected = false;
    this.kymw0300Model.dutiesFormSpotDivSelected = false;
    this.kymw0300Model.dataKbnFlg = false;

    // ログインユーザが取引先の場合、
    // 取引先関連条件の支払先コードにユーザの取引先情報を入れる
    // また、支払先コード、支払先名、支払先検索ボタンを非活性にする
    this.isSupplier = this.kymw00Model.kymw1001Model.isSupplier() && !PlessViewUtilsSub.isEmpty(this.sharedModel.kymw1001Model.loginUserInfo.SupplierCode);
    if (this.isSupplier) {
      this.kymw0300Model.payeeClientCode = this.sharedModel.kymw1001Model.loginUserInfo.SupplierCode;
      // 支払先名は取れないため空欄にしておく
      this.kymw0300Model.payeeClientKanji = '';
    } else {
      // ログインユーザが取引先ではない場合、前の検索条件を入れる
      this.kymw0300Model.payeeClientCode = this.inputVo.payeeClientCode;
      this.kymw0300Model.payeeClientKanji = this.inputVo.payeeClientKanji;
    }

    // 受け渡し情報がなければ以降の表示設定は行わない
    if (this.inputVo == null) {
      return;
    }

    // 検索区分をもとに表示するタブを設定
    switch(this.inputVo.searchKbn){
      case PANEL_TAB_INDEX.NOMAL:
        this.kymw0300Model.tabSelectedIndex = PANEL_TAB_INDEX.NOMAL;
        // 通常検索タブのとき、dataKbnFlgに格納
        this.kymw0300Model.dataKbnFlg = this.inputVo.dataKbnFlg;
        break;
      case PANEL_TAB_INDEX.P_CODE_LIST:
        this.kymw0300Model.tabSelectedIndex = PANEL_TAB_INDEX.P_CODE_LIST;
        // リスト検索（Pコード）タブのとき、dataKbnFlg_pcodeListに格納
        this.kymw0300Model.dataKbnFlg_pcodeList = this.inputVo.dataKbnFlg;
        break;
      case PANEL_TAB_INDEX.ITEM_CODE_LIST:
        this.kymw0300Model.tabSelectedIndex = PANEL_TAB_INDEX.ITEM_CODE_LIST;
        // リスト検索（アイテムコード）タブのとき、dataKbnFlg_itemCodeListに格納
        this.kymw0300Model.dataKbnFlg_itemCodeList = this.inputVo.dataKbnFlg;
        break;
    }
    // 受渡情報の設定
    this.kymw0300Model.pcode = this.inputVo.pcode;
    this.kymw0300Model.itemCode = this.inputVo.itemCode;
    this.kymw0300Model.janCode = this.inputVo.janCode;
    this.kymw0300Model.makerName = this.inputVo.makerName;
    this.kymw0300Model.guideGoodsName = PlessViewUtilsSub.arrayToString(
      this.inputVo.guideGoodsNameList,
      DELIMITER_CHAR.GUIDE
    );
    this.kymw0300Model.guideStandardName = PlessViewUtilsSub.arrayToString(
      this.inputVo.guideStandardNameList,
      DELIMITER_CHAR.GUIDE
    );
    this.kymw0300Model.tagId = this.inputVo.tagId;
    this.kymw0300Model.tagOutput = this.inputVo.tagOutput;
    this.kymw0300Model.tagSearchType = this.inputVo.tagSearchType;
    if(this.kymw0300Model.tagOutput) {
      this.tagLength = this.kymw0300Model.tagOutput.length;
    }
    this.kymw0300Model.goodsMark = this.inputVo.goodsMark;
    this.kymw0300Model.goodsMarkSearchType = this.inputVo.goodsMarkSearchType;
    this.kymw0300Model.goodsMarkOutput = this.inputVo.goodsMarkOutput;
    if(this.kymw0300Model.goodsMarkOutput) {
      this.goodsMarkLength = this.kymw0300Model.goodsMarkOutput.length;
    }
    this.kymw0300Model.ordrClientCode = this.inputVo.ordrClientCode;
    this.kymw0300Model.ordrClientKanji = this.inputVo.ordrClientKanji;
    this.kymw0300Model.orderCode = this.inputVo.orderCode;
    this.kymw0300Model.catalogId = this.inputVo.catalogId;
    this.kymw0300Model.mediumType = this.inputVo.mediumType;
    this.kymw0300Model.specialFeature = this.inputVo.specialFeature;
    this.kymw0300Model.catalogMark = this.inputVo.catalogCode;
    this.kymw0300Model.catalogMarkSearchType = this.inputVo.catalogCodeSearchType;
    this.kymw0300Model.catalogMarkOutput = this.inputVo.catalogMarkOutput;
    if(this.kymw0300Model.catalogMarkOutput) {
      this.catalogMarkLength = this.kymw0300Model.catalogMarkOutput.length;
    }
    this.kymw0300Model.pageNo = this.inputVo.pageNo;
    this.kymw0300Model.pageInput = this.inputVo.pageInput;
    this.kymw0300Model.duties = this.inputVo.duties;

    // 部門・分類
    this.kymw0300Model.classCode = this.inputVo.classCode;
    this.cmb_ClassCode.setClassCode(this.inputVo.classCode);
    this.kymw0300Model.middleClassCode = this.inputVo.middleClassCode;
    this.cmb_MiddleClassification.setMiddleClassCode(
      this.inputVo.middleClassCode
    );
    this.kymw0300Model.smallClassCode = this.inputVo.smallClassCode;
    this.cmb_SmallClassification.setSmallClassCode(this.inputVo.smallClassCode);

    // 商品マスタ登録日
    this.kymw0300Model.registDateFrom = this.inputVo.registDateFrom;
    this.kymw0300Model.registDateTo = this.inputVo.registDateTo;

    // 商品マスタ更新日
    this.kymw0300Model.updateDateFrom = this.inputVo.updateDateFrom;
    this.kymw0300Model.updateDateTo = this.inputVo.updateDateTo;

    // 生協コード
    this.setCoopCode(this.inputVo.coopCodeList);
    this.eventSeikyou_CLICKHandler();

    // 業態区分
    if (!PlessViewUtilsSub.isEmptyArray(this.inputVo.duties)) {
      for (let i = Number(0); this.inputVo.duties.length > i; i++) {
        this.lst_DutiesFormDaily.updateCheckCodeValue(this.inputVo.duties[i], true);
      }
    }


    // バイヤーコード
    this.kymw0300Model.buyerCode = this.inputVo.buyerCode;
    this.cmb_BuyerCode.model.setCodeValue = this.inputVo.buyerCode;

    // 登録レベル
    this.kymw0300Model.admitStatus = CodeComboBoxComponent.convertToLocalAdminStatus(this.inputVo.admitStatus);
    this.cmb_admitStatus.model.setCodeValue = CodeComboBoxComponent.convertToLocalAdminStatus(this.inputVo.admitStatus);

    // ダミー商品
    this.kymw0300Model.dummyGoodsSelected =
      this.inputVo.goodsDiv === '1' ? true : false;

    // Pコードリスト
    document
      .getElementById('txta_PcodeList')
      .addEventListener('input', () => this.eventPcodeListHandler());
    this.kymw0300Model.pcodeList = PlessViewUtilsSub.arrayToString(this.inputVo.pcodeList, '\n');
    this.pcodeCount = this.inputVo.pcodeList.length;

    // アイテムコードリスト
    document
      .getElementById('txta_ItemcodeList')
      .addEventListener('input', () => this.eventItemcodeListHandler());
    this.kymw0300Model.itemcodeList = PlessViewUtilsSub.arrayToString(this.inputVo.itemCodeList, '\n');
    this.itemcodeCount = this.inputVo.itemCodeList.length;

    // 呼び出し元の画面から取得した企画検索フラグの値によって表示を切り替える
    // 企画関連条件「0（商品検索）:非表示」「1（企画検索）:表示」
    if (this.inputVo.catalogSearchFlg === 1) {
      this.kymw0300Model.catalogConditionVisible = STYLE_VISIBILITY.SHOW; // 「企画関連条件」アコーディオンの表示
    } else {
      this.kymw0300Model.catalogConditionVisible = STYLE_VISIBILITY.HIDDEN; // 「企画関連条件」アコーディオンの非表示
    }

    setTimeout(() => {
      this.tbx_PCode.nativeElement.focus();
    });
  }

  /**
   * 検索ボタンを押下した時に呼び出されるメソッド。
   */
  public eventCreateTargetListHandler() {
    const outputVO: KYMW0300OutputModel = new KYMW0300OutputModel();
    // 通常検索タブ選択時
    if (this.kymw0300Model.tabSelectedIndex === PANEL_TAB_INDEX.NOMAL) {
      // 検索条件がすべて未入力であればメッセージ表示
      if (!this.checkSerchCondition()) {
        this.dialogService.openAlertGetMessage('E0143');
        return;
      }

      // マスタ登録日前後チェック
      if (this.kymw0300Model.registDateFrom && this.kymw0300Model.registDateTo) {
        if (this.kymw0300Model.registDateFrom > this.kymw0300Model.registDateTo) {
          this.dialogService.openAlertGetMessage('E0123', ['マスタ登録日']);
          return;
        }
      }

      // マスタ更新日前後チェック
      if (this.kymw0300Model.updateDateFrom && this.kymw0300Model.updateDateTo) {
        if (this.kymw0300Model.updateDateFrom > this.kymw0300Model.updateDateTo) {
          this.dialogService.openAlertGetMessage('E0123', ['マスタ更新日']);
          return;
        }
      }

      // 検索区分設定
      outputVO.searchKbn = 0;

      // 検索条件をKYMW0300OutputVOに設定
      outputVO.pcode = this.kymw0300Model.pcode;
      outputVO.itemCode = this.kymw0300Model.itemCode;
      outputVO.janCode = this.kymw0300Model.janCode;
      outputVO.makerName = this.kymw0300Model.makerName;
      outputVO.guideGoodsNameList = this.split(
        this.replaceAll(this.kymw0300Model.guideGoodsName),
        DELIMITER_CHAR.GUIDE
      );
      outputVO.guideStandardNameList = this.split(
        this.replaceAll(this.kymw0300Model.guideStandardName),
        DELIMITER_CHAR.GUIDE
      );
      outputVO.ordrClientCode = this.kymw0300Model.ordrClientCode;
      outputVO.ordrClientKanji = this.kymw0300Model.ordrClientKanji;
      outputVO.payeeClientCode = this.kymw0300Model.payeeClientCode;
      outputVO.payeeClientKanji = this.kymw0300Model.payeeClientKanji;

      // 部門・分類
      outputVO.classCode = this.cmb_ClassCode.selectedClassCode;
      outputVO.middleClassCode =
        this.cmb_MiddleClassification.selectedMiddleClassCode;
      outputVO.smallClassCode =
        this.cmb_SmallClassification.selectedSmallClassCode;

      // マスタ登録日
      outputVO.registDateFrom = this.kymw0300Model.registDateFrom;
      outputVO.registDateTo = this.kymw0300Model.registDateTo;

      // 更新日
      outputVO.updateDateFrom = this.kymw0300Model.updateDateFrom;
      outputVO.updateDateTo = this.kymw0300Model.updateDateTo;

      // 取扱可能生協
      // 生協コードの配列を文字列でつなげる
      outputVO.coopCodeList = this.getCoopCodeArray();

      // 登録レベル(空白：全体、0:eBASE取込後、1:仮登録、2:本登録)
      outputVO.admitStatus = CodeComboBoxComponent.convertToParentAdminStatus(this.kymw0300Model.admitStatus);

      // バイヤーコード
      if (PlessViewUtilsSub.isEmpty(this.kymw0300Model.buyerCode)) {
        outputVO.buyerCode = '';
      } else {
        outputVO.buyerCode = this.kymw0300Model.buyerCode;
      }

      // ダミー商品チェックボックスが選択されている場合は、「1:ダミー商品」とする
      outputVO.goodsDiv = this.kymw0300Model.dummyGoodsSelected ? '1' : '';

      // 業態区分(デイリー）
      const selectedDailyArray = [];
      for (
        let i = Number(0);
        i < this.lst_DutiesFormDaily.codeList.length;
        i++
      ) {
        if (this.lst_DutiesFormDaily.codeList[i].selectedValue === true) {
          selectedDailyArray.push(
            this.lst_DutiesFormDaily.codeList[i].CodeValue
          );
        }
      }
      outputVO.duties = selectedDailyArray;

      // タグ
      const selectedTagIdArray = [];
      if (this.kymw0300Model.tagOutput != null) {
        if (this.kymw0300Model.tagOutput.length > this.MAX_LENGTH_FOR_TAGS) {
          this.dialogService.openAlertGetMessage('E0586', [
            'タグ',
            this.MAX_LENGTH_FOR_TAGS.toString(),
          ]);
          return;
        } else {
          for (
            let i = Number(0);
            i < this.kymw0300Model.tagOutput.length;
            i++
          ) {
            selectedTagIdArray.push(this.kymw0300Model.tagOutput[i].tagId);
          }
        }
      }
      outputVO.tagId = selectedTagIdArray;
      // タグ検索方法
      outputVO.tagSearchType = this.kymw0300Model.tagSearchType;
      // タグ再表示用
      outputVO.tagOutput = this.kymw0300Model.tagOutput;

      // 商品マーク
      const selectedGoodsMarkCodeArray = [];
      if (this.kymw0300Model.goodsMarkOutput != null) {
        if (
          this.kymw0300Model.goodsMarkOutput.length >
          this.MAX_LENGTH_FOR_GOODS_MARK
        ) {
          this.dialogService.openAlertGetMessage('E0586', [
            '商品マーク',
            this.MAX_LENGTH_FOR_GOODS_MARK.toString(),
          ]);
          return;
        } else {
          for (
            let i = Number(0);
            i < this.kymw0300Model.goodsMarkOutput.length;
            i++
          ) {
            selectedGoodsMarkCodeArray.push(
              this.kymw0300Model.goodsMarkOutput[i].markCode
            );
          }
        }
      }
      outputVO.goodsMark = selectedGoodsMarkCodeArray;
      // 商品マーク検索方法
      outputVO.goodsMarkSearchType = this.kymw0300Model.goodsMarkSearchType;
      // 商品マーク再表示用
      outputVO.goodsMarkOutput = this.kymw0300Model.goodsMarkOutput;

      // 取扱終了商品を含む
      outputVO.dataKbnFlg = this.kymw0300Model.dataKbnFlg;

      // 媒体
      outputVO.mediumType = this.kymw0300Model.mediumType;

      // 受注コード
      outputVO.orderCode = this.kymw0300Model.orderCode;

      // 企画回再表示用
      outputVO.catalogId = this.kymw0300Model.catalogId;

      // 特集コード
      outputVO.specialFeature = this.kymw0300Model.specialFeature;

      // 企画マーク
      const selectedCatalogMarkCodeArray = [];
      if (this.kymw0300Model.catalogMarkOutput != null) {
        if (
          this.kymw0300Model.catalogMarkOutput.length >
          this.MAX_LENGTH_FOR_CATALOG_MARK
        ) {
          this.dialogService.openAlertGetMessage('E0586', [
            '企画マーク',
            this.MAX_LENGTH_FOR_CATALOG_MARK.toString(),
          ]);
          return;
        } else {
          for (
            let i = Number(0);
            i < this.kymw0300Model.catalogMarkOutput.length;
            i++
          ) {
            selectedCatalogMarkCodeArray.push(
              this.kymw0300Model.catalogMarkOutput[i].markCode
            );
          }
        }
      }
      outputVO.catalogCode = selectedCatalogMarkCodeArray;
      // 企画マーク検索方法
      outputVO.catalogCodeSearchType = this.kymw0300Model.catalogMarkSearchType;
      // 企画マーク再表示用
      outputVO.catalogMarkOutput = this.kymw0300Model.catalogMarkOutput;

      // ページNO
      this.createPageNoArray();
      outputVO.pageNo = this.kymw0300Model.pageNo;
      // ページ再表示用
      outputVO.pageInput = this.kymw0300Model.pageInput;

      // Pコードリスト検索タブ選択時
    } else if (
      this.kymw0300Model.tabSelectedIndex === PANEL_TAB_INDEX.P_CODE_LIST
    ) {

      // Pコードリストの必須チェック
      const t = this.kymw0300Model.pcodeList.trim();
      if (PlessViewUtilsSub.isEmpty(t)) {
        this.dialogService.openAlertGetMessage('E0143');
        return;
      }

      const pCodeList:Array<string> = t.split(DELIMITER_CHAR.PCODE);

      // Pコード形式チェック(1件でも不正値があればエラー)
      const isFormatError:boolean = pCodeList.some((pcode) => !PlessViewUtilsSub.isEmpty(pcode) && !PlessViewUtilsSub.validatePCode(pcode));
      if (isFormatError) {
        this.dialogService.openAlertGetMessage('W0024', ['Pコード'], () => {});
        return;
      }

      // 検索区分設定
      outputVO.searchKbn = 1;
      // 検索条件をKYMW0300OutputVOに設定
      outputVO.pcodeList = pCodeList;

      // 取扱終了商品を含む
      outputVO.dataKbnFlg = this.kymw0300Model.dataKbnFlg_pcodeList;

      // アイテムコードリスト検索タブ選択時
    } else if (
      this.kymw0300Model.tabSelectedIndex === PANEL_TAB_INDEX.ITEM_CODE_LIST
    ) {
      // アイテムコードリストの必須チェック
      const t = this.kymw0300Model.itemcodeList.trim();
      if (PlessViewUtilsSub.isEmpty(t)) {
        this.dialogService.openAlertGetMessage('E0143');
        return;
      }

      const itemCodeList:Array<string> = t.split(DELIMITER_CHAR.ITEM_CODE);

      // アイテムコード桁数チェック(1件でも不正値があればエラー)
      const isDigitError:boolean = itemCodeList.some((itemCode) => !PlessViewUtilsSub.isEmpty(itemCode) && itemCode.length !== 7);
      if (isDigitError) {
        this.dialogService.openAlertGetMessage('W0024', ['アイテムコード'], () => {});
        return;
      }

      // 検索区分設定
      outputVO.searchKbn = 2;
      // 検索条件をKYMW0300OutputVOに設定
      outputVO.itemcodeList = itemCodeList;
      
      // 取扱終了商品を含む
      outputVO.dataKbnFlg = this.kymw0300Model.dataKbnFlg_itemCodeList;
    }

    this.setKYMW0300Parameter(outputVO);
    this.closeFunction();
  }

  /**
   * 発注先の検索ボタンをCLICKした時に呼び出されるメソッド。
   */
  public eventSearchOrdrClientHandler(event: Event): void {
    // 「商品検索ポップアップ用インプットVO」の生成
    const vo: KYMW0400InputModel = { supplierFlg: '0', isMultiCheckable: false }; // 発注先
    const instance: KYMW0400Component =
      this.createKymw0400ComponentInstance(vo);
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => {
      this.kymw0300Model.ordrClientCode = outputVO.supplierCode;
      this.kymw0300Model.ordrClientKanji = outputVO.supplierNameKanji;
    };
  }

  /**
   * 支払先の検索ボタンをCLICKした時に呼び出されるメソッド。
   */
  public eventSearchPayeeHandler(event: Event): void {
    const vo: KYMW0400InputModel = { supplierFlg: '1', isMultiCheckable: false }; // 支払先
    const instance: KYMW0400Component =
      this.createKymw0400ComponentInstance(vo);
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => {
      this.kymw0300Model.payeeClientCode = outputVO.supplierCode;
      this.kymw0300Model.payeeClientKanji = outputVO.supplierNameKanji;
    };
  }

  /**
   * 商品検索ポップアップを表示
   *
   * @private
   * @param {KYMW0400InputModel} vo
   * @memberof KYMW0300Component
   */
  private createKymw0400ComponentInstance(
    vo: KYMW0400InputModel
  ): KYMW0400Component {
    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
    return instance;
  }

  /**
   * Arrayを元に生協コードのチェックを行う。
   **/
  private setCoopCode(baseArray: string[]): void {
    if (baseArray == null) {
      return;
    }

    for (let i = Number(0); i < baseArray.length; i++) {
      if (baseArray[i] === this.kymw00Model.COOP_CODE_IB) {
        this.kymw0300Model.seikyou1Selected = true; // いばらき
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_TO) {
        this.kymw0300Model.seikyou2Selected = true; // とちぎ
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_GU) {
        this.kymw0300Model.seikyou3Selected = true; // ぐんま
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_TI) {
        this.kymw0300Model.seikyou4Selected = true; // ちば
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_SA) {
        this.kymw0300Model.seikyou5Selected = true; // さいたま
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_TK) {
        this.kymw0300Model.seikyou6Selected = true; // とうきょう
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_NA) {
        this.kymw0300Model.seikyou7Selected = true; // ながの
      } else if (baseArray[i] === this.kymw00Model.COOP_CODE_NI) {
        this.kymw0300Model.seikyou8Selected = true; // にいがた
      }
    }
  }

  /**
   * 生協コードを取得
   * チェックされた生協のみArrayにセットし返却
   **/
  private getCoopCodeArray(): string[] {
    const returnArray: string[] = [];
    if (this.kymw0300Model.seikyou1Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_IB); // いばらき
    }
    if (this.kymw0300Model.seikyou2Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_TO); // とちぎ
    }
    if (this.kymw0300Model.seikyou3Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_GU); // ぐんま
    }
    if (this.kymw0300Model.seikyou4Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_TI); // ちば
    }
    if (this.kymw0300Model.seikyou5Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_SA); // さいたま
    }
    if (this.kymw0300Model.seikyou6Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_TK); // とうきょう
    }
    if (this.kymw0300Model.seikyou7Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_NA); // ながの
    }
    if (this.kymw0300Model.seikyou8Selected) {
      returnArray.push(this.kymw00Model.COOP_CODE_NI); // にいがた
    }

    return returnArray;
  }

  private split(str: string, delimiter: string): string[] {
    if (PlessViewUtilsSub.isEmpty(str)) {
      return [''];
    }
    return str.trim().split(delimiter);
  }

  /**
   * 条件クリアボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventConditionClearHandler(event: Event): void {
    // 初期化
    this.kymw0300Model.pcode = '';
    this.kymw0300Model.itemCode = '';
    this.kymw0300Model.janCode = '';
    this.kymw0300Model.makerName = '';
    this.kymw0300Model.guideGoodsName = '';
    this.kymw0300Model.guideStandardName = '';
    this.kymw0300Model.ordrClientCode = '';
    this.kymw0300Model.ordrClientKanji = '';
    if (!this.isSupplier) this.kymw0300Model.payeeClientCode = '';
    if (!this.isSupplier) this.kymw0300Model.payeeClientKanji = '';
    this.kymw0300Model.registDateCheck = false;
    this.kymw0300Model.registDateFrom = '';
    this.kymw0300Model.registDateTo = '';
    this.kymw0300Model.updateDateCheck = false;
    this.kymw0300Model.updateDateFrom = '';
    this.kymw0300Model.updateDateTo = '';
    this.kymw0300Model.seikyou1Selected = false;
    this.kymw0300Model.seikyou2Selected = false;
    this.kymw0300Model.seikyou3Selected = false;
    this.kymw0300Model.seikyou4Selected = false;
    this.kymw0300Model.seikyou5Selected = false;
    this.kymw0300Model.seikyou6Selected = false;
    this.kymw0300Model.seikyou7Selected = false;
    this.kymw0300Model.seikyou8Selected = false;
    this.kymw0300Model.allCoop = false;
    this.kymw0300Model.whole = '0';
    this.kymw0300Model.buyerCode = '';
    this.kymw0300Model.pcodeList = '';
    this.pcodeCount = 0;
    this.kymw0300Model.itemcodeList = '';
    this.itemcodeCount = 0;
    this.kymw0300Model.dummyGoodsSelected = false;
    this.kymw0300Model.dutiesFormWeeklyDivSelected = false;
    this.kymw0300Model.dutiesFormSpotDivSelected = false;
    this.cmb_BuyerCode.setCodeValue('');
    this.lst_DutiesFormDaily.updateCheckCodeValue(null, false);
    this.cmb_ClassCode.setClassCode('');
    this.kymw0300Model.classCode = '';
    this.kymw0300Model.middleClassCode = '';
    this.kymw0300Model.smallClassCode = '';
    this.kymw0300Model.orderCode = '';
    this.kymw0300Model.dataKbnFlg = false;
    this.kymw0300Model.tagOutput = [];
    this.tagLength = 0;
    this.kymw0300Model.tagSearchType = 'AND';
    this.kymw0300Model.goodsMarkOutput = [];
    this.goodsMarkLength = 0;
    this.kymw0300Model.goodsMarkSearchType = 'OR';
    this.kymw0300Model.mediumType = '';
    this.kymw0300Model.catalogId = '';
    this.cmb_admitStatus.setSelectedIndex(0);
    this.catalogMarkLength = 0;
  }

  /**
   * Ｐコードリストに入力した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventPcodeListHandler(): void {
    const ary: Array<any> = PlessViewUtilsSub.formatList(
      this.kymw0300Model.pcodeList.split('\n'),
      1000
    );
    // 件数をカウントする
    this.pcodeCount = ary.length;
    if (ary.length == 1 && ary[0] == '') {
      this.pcodeCount = 0;
    }
    this.kymw0300Model.pcodeList = PlessViewUtilsSub.arrayToString(ary, '\n');
  }

  /**
   * アイテムコードリストに入力した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventItemcodeListHandler(): void {
    let ary: Array<any> = PlessViewUtilsSub.formatList(
      this.kymw0300Model.itemcodeList.split('\n'),
      1000
    );
    // 件数をカウントする
    this.itemcodeCount = ary.length;
    if (ary.length == 1 && ary[0] == '') {
      this.itemcodeCount = 0;
    }
    this.kymw0300Model.itemcodeList = PlessViewUtilsSub.arrayToString(
      ary,
      '\n'
    );
  }

  /**
   * アイテムコードリストのコードが全て7桁になるように0埋めを行う
   */
  public itemcodeListPaddingZero(): void {
    let ary: Array<any> = PlessViewUtilsSub.formatList(
      this.kymw0300Model.itemcodeList.split('\n'),
      1000
    );
    for (let i = Number(0); i < ary.length; i++) {
      if (!PlessViewUtilsSub.isEmpty(ary[i])) {
        ary[i] = PlessViewUtilsSub.padding(ary[i], 7, '0', 1);
      }
    }
    this.kymw0300Model.itemcodeList = PlessViewUtilsSub.arrayToString(
      ary,
      '\n'
    );
  }

  /**
   * 検索条件の必須チェックを行う
   * ひとつでも値があれば、trueを返す
   **/
  private checkSerchCondition(): boolean {
    // 空欄のチェック
    const chkEmptyValues = [
      this.kymw0300Model.pcode,
      this.kymw0300Model.itemCode,
      this.kymw0300Model.janCode,
      this.kymw0300Model.makerName,
      this.kymw0300Model.guideGoodsName,
      this.kymw0300Model.guideStandardName,
      this.kymw0300Model.ordrClientCode,
      this.kymw0300Model.ordrClientKanji,
      this.kymw0300Model.payeeClientCode,
      this.kymw0300Model.payeeClientKanji,
      this.kymw0300Model.classCode,
      this.kymw0300Model.middleClassCode,
      this.kymw0300Model.smallClassCode,
      this.kymw0300Model.buyerCode,
      this.kymw0300Model.registDateFrom,
      this.kymw0300Model.registDateTo,
      this.kymw0300Model.updateDateFrom,
      this.kymw0300Model.updateDateTo,
      this.kymw0300Model.mediumType,
      this.kymw0300Model.orderCode,
      this.kymw0300Model.specialFeature,
      this.kymw0300Model.pageInput,
    ];
    const notEmptyTarget = chkEmptyValues.filter(
      item => !PlessViewUtilsSub.isEmpty(item)
    );
    if (!PlessViewUtilsSub.isEmptyArray(notEmptyTarget)) {
      return true;
    }

    // 空のチェック
    const chkEmptyArrays = [
      this.kymw0300Model.tagOutput,
      this.kymw0300Model.goodsMarkOutput,
      this.kymw0300Model.catalogMarkOutput,
    ];
    const notEmptyArraysTarget = chkEmptyArrays.filter(
      index => !PlessViewUtilsSub.isEmptyArray(index)
    );
    if (!PlessViewUtilsSub.isEmptyArray(notEmptyArraysTarget)) {
      return true;
    }

    // 未選択チェック
    const checkboxTarget = [
      this.kymw0300Model.seikyou1Selected,
      this.kymw0300Model.seikyou2Selected,
      this.kymw0300Model.seikyou3Selected,
      this.kymw0300Model.seikyou4Selected,
      this.kymw0300Model.seikyou5Selected,
      this.kymw0300Model.seikyou6Selected,
      this.kymw0300Model.seikyou7Selected,
      this.kymw0300Model.seikyou8Selected,
      this.kymw0300Model.dummyGoodsSelected,
      this.kymw0300Model.dataKbnFlg,
    ];
    const checkedTarget = checkboxTarget.filter(checked => checked);
    if (!PlessViewUtilsSub.isEmptyArray(checkedTarget)) {
      return true;
    }

    // 業態区分（デイリー）
    const dailyCheckeItem = this.lst_DutiesFormDaily.codeList.filter(
      item => item.selectedValue === true
    );
    if (!PlessViewUtilsSub.isEmptyArray(dailyCheckeItem)) {
      return true;
    }
    return false;
  }

  /**
   * 全角の空白を半角の空白に返す。
   * replace()メソッドを呼びだす。
   **/
  private replaceAll(trg: string): string {
    let returnString: string = trg;
    while (returnString.indexOf('　') > -1) {
      returnString = returnString.replace('　', ' ');
    }
    return returnString;
  }

  /**
   * 「ALL」チェックボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventAllCoop_CLICKHandler() {
    this.allCoop = this.kymw0300Model.allCoop;

    this.kymw0300Model.seikyou1Selected = this.allCoop;
    this.kymw0300Model.seikyou2Selected = this.allCoop;
    this.kymw0300Model.seikyou3Selected = this.allCoop;
    this.kymw0300Model.seikyou4Selected = this.allCoop;
    this.kymw0300Model.seikyou5Selected = this.allCoop;
    this.kymw0300Model.seikyou6Selected = this.allCoop;
    this.kymw0300Model.seikyou7Selected = this.allCoop;
    this.kymw0300Model.seikyou8Selected = this.allCoop;
  }

  /**
   * 生協のチェックを変更したときのイベント処理
   *  @event イベント
   */
  public eventSeikyou_CLICKHandler() {
    const seikyouCheckboxTarget = [
      this.kymw0300Model.seikyou1Selected,
      this.kymw0300Model.seikyou2Selected,
      this.kymw0300Model.seikyou3Selected,
      this.kymw0300Model.seikyou4Selected,
      this.kymw0300Model.seikyou5Selected,
      this.kymw0300Model.seikyou6Selected,
      this.kymw0300Model.seikyou7Selected,
      this.kymw0300Model.seikyou8Selected,
    ];
    // チェックされた生協のチェックボックスを格納
    const seikyouCheckedTarget = seikyouCheckboxTarget.filter(
      checked => checked
    );

    // チェックされた生協の数が全生協の数と一致しているか（一致：「ALL」をチェック、不一致：「ALL」からチェックを外す）
    if (seikyouCheckedTarget.length === seikyouCheckboxTarget.length) {
      this.kymw0300Model.allCoop = true;
    } else {
      this.kymw0300Model.allCoop = false;
    }
  }

  /**
   * タグの選択ボタンをCLICKした時に呼び出されるメソッド
   */
  public eventSelectTagHandler(): void {
    // タグ選択画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0002Component);
    const instance = componentRef.componentInstance as KYMW0002Component;
    instance.parent = this;
    if (PlessViewUtilsSub.isEmptyArray(this.setId) && (this.kymw0300Model.tagOutput && this.kymw0300Model.tagOutput.length > 0)) {
      this.setId = this.kymw0300Model.tagOutput.map(tags => tags.tagId);
    }
    instance.setParams(this.setId);
    // ウィンドウが閉じられる際の処理
    instance.closeFunction = () => {
      if (instance.getParams() !== null) {
        this.kymw0300Model.tagOutput = instance.getParams();
        this.setId = [];
        for (let i = 0; i < this.kymw0300Model.tagOutput.length; i++) {
          this.setId.push(this.kymw0300Model.tagOutput[i].tagId);
        }
        this.tagLength = this.kymw0300Model.tagOutput.length;
      }
      componentRef.close();
    };
  }

  /**
   * 商品マークの選択ボタンをCLICKした時に呼び出されるメソッド
   */
  public eventSelectGoodsMarkHandler(): void {
    // マーク選択画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0001Component);
    const instance = componentRef.componentInstance as KYMW0001Component;
    instance.parent = this;
    if (PlessViewUtilsSub.isEmptyArray(this.setGoodsMarkCode) && (this.kymw0300Model.goodsMarkOutput && this.kymw0300Model.goodsMarkOutput.length > 0)) {
      this.setGoodsMarkCode = this.kymw0300Model.goodsMarkOutput.map(
        marks => marks.markCode
      );
    }
    // マーク選択画面にパラメータを渡す
    const goodsMarkParams: KYMW0001InputModel = {
      orderCode: '',
      windowOpenFlg: 0,
      inputParam: this.setGoodsMarkCode,
    };
    instance.setParams(goodsMarkParams);
    // ウィンドウが閉じられる際の処理
    instance.closeFunction = () => {
      if (instance.getParams() !== null) {
        this.kymw0300Model.goodsMarkOutput = instance.getParams();
        this.setGoodsMarkCode = [];
        for (let i = 0; i < this.kymw0300Model.goodsMarkOutput.length; i++) {
          this.setGoodsMarkCode.push(this.kymw0300Model.goodsMarkOutput[i].markCode);
        }
        this.goodsMarkLength = this.kymw0300Model.goodsMarkOutput.length;
      }
      componentRef.close();
    };
  }

  /**
   * 企画マークの選択ボタンをCLICKした時に呼び出されるメソッド
   */
  public eventSelectCatalogMarkHandler(): void {
    // マーク選択画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0001Component);
    const instance = componentRef.componentInstance as KYMW0001Component;
    instance.parent = this;
    // マーク選択画面にパラメータを渡す
    if (PlessViewUtilsSub.isEmptyArray(this.setCatalogMarkCode) && (this.kymw0300Model.catalogMarkOutput && this.kymw0300Model.catalogMarkOutput.length > 0)) {
      this.setCatalogMarkCode = this.kymw0300Model.catalogMarkOutput.map(
        marks => marks.markCode
      );
    }
    const catalogMarkParams: KYMW0001InputModel = {
      orderCode: this.kymw0300Model.orderCode,
      windowOpenFlg: 1,
      inputParam: this.setCatalogMarkCode,
    };
    instance.setParams(catalogMarkParams);
    // ウィンドウが閉じられる際の処理
    instance.closeFunction = () => {
      if (instance.getParams() !== null) {
        this.kymw0300Model.catalogMarkOutput = instance.getParams();
        this.setCatalogMarkCode = [];
        for (let i = 0; i < this.kymw0300Model.catalogMarkOutput.length; i++) {
          this.setCatalogMarkCode.push(
            this.kymw0300Model.catalogMarkOutput[i].markCode
          );
        }
        this.catalogMarkLength = this.kymw0300Model.catalogMarkOutput.length;
      }
      componentRef.close();
    };
  }

  /**
   * ボタン押下 設定済みのタグ X
   *
   * @param removeId
   * @memberof KYMW0300Component
   */
  public removeTag(removeId: string, type: string) {
    if (type === 'tag') {
      this.kymw0300Model.tagOutput = this.kymw0300Model.tagOutput.filter(
        index => removeId !== index.tagId
      );
      this.tagLength = this.kymw0300Model.tagOutput.length;
      this.setId = this.kymw0300Model.tagOutput.map(tags => tags.tagId);
    } else if (type === 'goodsMark') {
      this.kymw0300Model.goodsMarkOutput =
        this.kymw0300Model.goodsMarkOutput.filter(
          index => removeId !== index.markCode
        );
      this.goodsMarkLength = this.kymw0300Model.goodsMarkOutput.length;
      this.setGoodsMarkCode = this.kymw0300Model.goodsMarkOutput.map(
        marks => marks.markCode
      );
    } else if (type === 'catalogMark') {
      this.kymw0300Model.catalogMarkOutput =
        this.kymw0300Model.catalogMarkOutput.filter(
          index => removeId !== index.markCode
        );
      this.catalogMarkLength = this.kymw0300Model.catalogMarkOutput.length;
      this.setCatalogMarkCode = this.kymw0300Model.catalogMarkOutput.map(
        marks => marks.markCode
      );
    }
  }

  /**
   * 媒体コンボボックス変更時
   *
   * @memberof KYMW0300Component
   */
  public eventMediumType_CHANGEHandler(): void {
    // 受注コード、企画回、特集コードをクリア
    this.kymw0300Model.orderCode = '';
    this.kymw0300Model.catalogId = '';
    this.kymw0300Model.specialFeature = '';
  }

  /**
   * 受注コード変更時
   *
   * @memberof KYMW0300Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    // 受注コードが7桁入力されて媒体が入力されていたらAPI呼び出し
    if (
      this.kymw0300Model.mediumType &&
      this.kymw0300Model.orderCode.length == 7
    ) {
      // 特集コード、企画マーク、ページNO入力可
      this.kymw0300Model.disabledspecialFeatureFlg = false;
      this.kymw0300Model.disabledCatalogMarkFlg = false;
      this.kymw0300Model.disabledPageNoFlg = false;
      // 特集コード取得
      this.getFeatureCodeList();
    } else if (
      !this.kymw0300Model.mediumType ||
      this.kymw0300Model.orderCode.length != 7
    ) {
      // 特集コードクリア、入力不可
      this.kymw0300Model.specialFeature = '';
      this.kymw0300Model.specialFeatureList = null;
      this.kymw0300Model.disabledspecialFeatureFlg = true;
      // 企画マーククリア、入力不可
      this.kymw0300Model.catalogMarkOutput = [];
      this.catalogMarkLength = 0;
      this.setCatalogMarkCode = [];
      this.kymw0300Model.disabledCatalogMarkFlg = true;
      this.kymw0300Model.catalogMarkSearchType = 'OR';
      // ページNOクリア、入力不可
      this.kymw0300Model.pageInput = '';
      this.kymw0300Model.pageNo = [];
      this.kymw0300Model.disabledPageNoFlg = true;
    }
  }

  /**
   * 企画マークの背景色の変更
   * @returns 背景色
   */
  getDisabledStyle() {
    if (this.kymw0300Model.disabledCatalogMarkFlg) {
      return { background: '#dddd' };
    } else {
      return { background: '#f9fafc' };
    }
  }

  /**
   * 特集コード格納
   *
   * @memberof KYMW0300Component
   */
  public getFeatureCodeList(): void {
    const vo = {
      OrderCode: this.kymw0300Model.orderCode,
      MediumType: this.kymw0300Model.mediumType,
    };

    this.getFeatureCodeListService.execute(vo, (data: any) => {
      this.kymw0300Model.specialFeatureList = data.map(
        index => new FeatureCodeListModel(index.FeatureCode, index.FeatureName)
      );
    });
  }

  /**
   * ページNO格納
   *
   * @memberof KYMW0300Component
   */
  public createPageNoArray(): void {
    // 文字列で受けとったページNOを,区切りで配列に格納
    let pageNoStringList = this.kymw0300Model.pageInput.split(',');
    // 格納用配列
    let pageNoList = [];

    for (let i = Number(0); i < pageNoStringList.length; i++) {
      if (pageNoStringList[i].includes('-')) {
        const removeHyphenList = this.createArrayRemoveHyphen(
          pageNoStringList[i]
        );
        pageNoList = pageNoList.concat(removeHyphenList);
      } else {
        pageNoList.push(pageNoStringList[i]);
      }

      this.kymw0300Model.pageNo = pageNoList;
    }
  }

  /**
   * ページNOのハイフン除去
   * @param pageNoIncludesHyphen
   * @returns
   */
  public createArrayRemoveHyphen(pageNoIncludesHyphen: string): string[] {
    const pageNoRemoveHyphenList = pageNoIncludesHyphen.split('-');
    let pageNoFrom = Number(pageNoRemoveHyphenList[0]);
    let pageNoTo = Number(pageNoRemoveHyphenList[1]);
    let arrayRemoveHyphen = [];

    if (pageNoFrom == pageNoTo) {
      // ハイフン前後が同じ値のとき
      arrayRemoveHyphen.push(pageNoFrom.toString());
      return arrayRemoveHyphen;
    } else {
      if (pageNoFrom > pageNoTo) {
        // From>Toのとき
        let temp = pageNoFrom;
        pageNoFrom = pageNoTo;
        pageNoTo = temp;
      }

      for (pageNoFrom; pageNoFrom < pageNoTo + 1; pageNoFrom++) {
        arrayRemoveHyphen.push(pageNoFrom.toString());
      }
    }
    return arrayRemoveHyphen;
  }

  public initCollapsed(wad: WjAccordion, collapsed: boolean = true) {
    wad.panes.forEach(_ => (_.isCollapsed = collapsed));
  }
}
